export default {"src":"/_next/static/media/icon_lock.d3942bda.svg","height":17,"width":14,"blurWidth":0,"blurHeight":0};